import SegmentSnippet from './snippets/Segment';

export const initialiseSegment = (analyticsEnabled: boolean) => {
  // don't initialise without user's consent
  if (analyticsEnabled) SegmentSnippet();
};
